import React, {PureComponent} from 'react'
import styled from 'styled-components'

import {Icon} from './Icon'


const Wrapper = styled.div`
  width: 100%;
  height:100%;
  padding: 5px 0px;
`
const Container = styled.div`
  width: 100%;
  height:100%;
  background: #fff;
  display: flex;
  padding: 10px;
  border-radius: 4px; 
  box-shadow: -2px 2px 17px -10px rgba(0,0,0,0.75);
`
const IconCircle = styled.div`
  width: 40px;
  min-width: 40px;
  min-height: 40px;
  height: 40px;
  background: ${(props)=> props.iconBg};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const TextArea = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 5px;
  width: 100%;
  align-items: center;
  font-size: 16px;
  color: #5a5a5a;
  & span{
    & span{
      font-size: 12px
    }
  }
`


class CardView extends PureComponent{
  state={
    open: false
  }
  render(){
    const {
      iconBg='orange', 
      name='Houses Sanctioned',
      iconName='home',
      iconWidth=20,
      value='-',
      ext,
      rupeeIcon
    } = this.props 
    return(
      <Wrapper>
        <Container>
          <IconCircle iconBg={iconBg}>
            <Icon width={iconWidth} height={iconWidth} icon={iconName} color='#fff' />
          </IconCircle>
          <TextArea>
            <span>{name}</span>
            <span>{rupeeIcon && <Icon width={11} height={11} icon='rupee' color='#5a5a5a' />}{value} {ext && <span>{ext}</span>}</span>
          </TextArea>
        </Container>
      </Wrapper>
     
    )
  }
}

export {CardView}